import React, { useState } from 'react'
import adminStyles from './adminStyles.module.css'
import axios from 'axios';

const ForgotPassword = () => {
      const [email,setEmail]=useState("");

      const clearData=()=>{
        setEmail("");
      }

  const forgotsubmitHandler = (e) => {
   e.preventDefault();
   axios.post("https://backendsurgylife-1.onrender.com/forgotpassword", { email })
    .then(res => {
        alert(res.data);
    })
    .catch(err => {
        alert("Error: " + err.message);
    });
};
  return (
    <main className={adminStyles.adminMain}>
              
                      <section className={adminStyles.breadgum}>
                          <div className='container'>
                              <div className='row'>
                                  <div className='col-md-12'>
                                      <h1>Forgot Password</h1>
                                  </div>
                              </div>
                          </div>
                      </section>




                <section className='my-5'>
                          <div className='container'>
                              <div className='row '>
                                  <div className='col-md-4 mx-auto'>
                                    <div className={adminStyles.bx_shadow}>
                                    <form onSubmit={forgotsubmitHandler}>
                                        
                               <div className='mb-3'>
                                   <input 

                                 type='email'
                                 name='email'
                                  placeholder='Username' 
                                  className='form-control'
                                  value={email}
                                  onChange={
                                    (e)=>setEmail(e.target.value)
                                  }
                                  />
                               </div>

                             
                                 <div className='mb-3'>
                                        <input type='button'
                                        value='Cancel'
                                        className='btn btn-danger me-2'
                                        onClick={clearData}
                                        />
                                <input 
                                type='submit' 
                                value='Submit'
                                className='btn btn-success'/>  

                                    </div>

                                    </form>
                                    </div>
                                  </div>
                              </div>
                          </div>
                      </section>

                      </main>
  )
}

export default ForgotPassword
